import { Role } from '@/shared-types/roleTypes';

export function hasPermission(
  permission: Role[],
  role: Role,
  editConfigEnabled?: boolean,
): boolean {
  if (editConfigEnabled) {
    return true;
  }
  return permission.includes(role);
}
